export default "__VITE_ASSET__21145948__"